import React, { useState, useMemo, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './DealerLocatorPage.css';
import indiaMap from '../assets/india-map-bihar.png';
import Header from '../components/Header';
import Footer from '../components/Footer';

const DEALERS_DATA = [
  {
    district: 'Muzaffarpur',
    hindi: 'मुजफ्फरपुर',
    count: 3,
    color: '#e8762e',
    mapPos: { top: '41%', left: '46%' },
    dealers: [
      { name: 'KISAN ENG WORKS', stars: 5, address: 'Bairia, Muzaffarpur', phone: '+91 9876543217', email: 'kisaneng@example.com', brand: 'BCS' },
      { name: 'Kisan Engineering Works', stars: 4, address: 'Muzaffarpur', phone: '+91 9876543233', email: 'kisanengworks@example.com', brand: 'Shaktiman' },
      { name: 'Ajay Auto', stars: 4, address: 'Muzaffarpur', phone: '+91 9876543264', email: 'ajayauto@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Sitamarhi',
    hindi: 'सीतामढ़ी',
    count: 2,
    color: '#4ba242',
    mapPos: { top: '32%', left: '47%' },
    dealers: [
      { name: 'CHAUDHARY AGRO AGENCY', stars: 4, address: 'Cinema Road, Sitamarhi', phone: '+91 9876543216', email: 'chaudhary@example.com', brand: 'BCS' },
      { name: 'Choudhary Agro Agency', stars: 4, address: 'Sitamarhi', phone: '+91 7739629064', email: 'choudharyagro@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Madhubani',
    hindi: 'मधुबनी',
    count: 2,
    color: '#4ba242',
    mapPos: { top: '32%', left: '55%' },
    dealers: [
      { name: 'Kisaan Agro House', stars: 4, address: 'Madhubani', phone: '+91 9204655802', email: 'kisaanagro@example.com', brand: 'Shaktiman' },
      { name: 'Adarsh Machinary', stars: 4, address: 'Madhubani', phone: '+91 7903151921', email: 'adarshmach@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Bhagalpur',
    hindi: 'भागलपुर',
    count: 2,
    color: '#e8762e',
    mapPos: { top: '51%', left: '66%' },
    dealers: [
      { name: 'VAIBHAV TRADING', stars: 4, address: 'Station Road, Bhagalpur', phone: '+91 9876543215', email: 'vaibhav@example.com', brand: 'BCS' },
      { name: 'Kisan Enterprises', stars: 4, address: 'Bhagalpur', phone: '+91 9386134667', email: 'kisanenterprises@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Khagaria',
    hindi: 'खगड़िया',
    count: 2,
    color: '#fbc02d',
    mapPos: { top: '48%', left: '62%' },
    dealers: [
      { name: 'BAJRANG AGRO AGENCY', stars: 4, address: 'NH-31, Khagaria', phone: '+91 9876543218', email: 'bajrang@example.com', brand: 'BCS' },
      { name: 'RK tractors', stars: 4, address: 'Khagaria', phone: '+91 9430633169', email: 'rktractors@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Lakhisarai',
    hindi: 'लखीसराय',
    count: 1,
    color: '#3b82f6',
    mapPos: { top: '53%', left: '57%' },
    dealers: [
      { name: 'PRAMOD ENTERPRISES', stars: 4, address: 'Main Market, Lakhisarai', phone: '+91 9876543219', email: 'pramod@example.com', brand: 'BCS' },
    ],
  },
  {
    district: 'Garkha',
    hindi: 'गरखा',
    count: 1,
    color: '#8b5cf6',
    mapPos: { top: '45%', left: '38%' },
    dealers: [
      { name: 'RAGHAW TRACTOR', stars: 4, address: 'Chhapra Road, Garkha', phone: '+91 9876543220', email: 'raghaw@example.com', brand: 'BCS' },
    ],
  },
  {
    district: 'Darbhanga',
    hindi: 'दरभंगा',
    count: 2,
    color: '#4ba242',
    mapPos: { top: '38%', left: '53%' },
    dealers: [
      { name: 'MADHAVI AGENCY', stars: 4, address: 'Laheriasarai, Darbhanga', phone: '+91 9876543221', email: 'madhavi@example.com', brand: 'BCS' },
      { name: 'Madhvi Agency', stars: 4, address: 'Darbhanga', phone: '+91 9876543255', email: 'madhviagency@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Lalganj',
    hindi: 'लालगंज',
    count: 1,
    color: '#e8762e',
    mapPos: { top: '45%', left: '42%' },
    dealers: [
      { name: 'MECHANICAL AGENCY', stars: 4, address: 'Main Bazar, Lalganj', phone: '+91 9876543222', email: 'mechanical@example.com', brand: 'BCS' },
    ],
  },
  {
    district: 'Gopalganj',
    hindi: 'गोपालगंज',
    count: 1,
    color: '#fbc02d',
    mapPos: { top: '37%', left: '38%' },
    dealers: [
      { name: 'RAGHAV AGRICULTURE', stars: 4, address: 'Hospital Road, Gopalganj', phone: '+91 9876543223', email: 'raghavagri@example.com', brand: 'BCS' },
    ],
  },
  {
    district: 'Siwan',
    hindi: 'सीवान',
    count: 2,
    color: '#3b82f6',
    mapPos: { top: '41%', left: '38%' },
    dealers: [
      { name: 'BABA AGRO AGENCY', stars: 4, address: 'Babunia Road, Siwan', phone: '+91 9876543224', email: 'baba@example.com', brand: 'BCS' },
      { name: 'SHAKTI AGRO', stars: 4, address: 'Siwan', phone: '+91 7033697878', email: 'shaktiagro@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Rosera',
    hindi: 'रोसेरा',
    count: 1,
    color: '#8b5cf6',
    mapPos: { top: '44%', left: '54%' },
    dealers: [
      { name: 'SHREE DURGA TRACTOR', stars: 4, address: 'Cinema Road, Rosera', phone: '+91 9876543225', email: 'shreedurga@example.com', brand: 'BCS' },
    ],
  },
  {
    district: 'Bihia',
    hindi: 'बिहिया',
    count: 1,
    color: '#4ba242',
    mapPos: { top: '48%', left: '39%' },
    dealers: [
      { name: 'BINOD ENGINEERING', stars: 4, address: 'Station Road, Bihia', phone: '+91 9876543226', email: 'binod@example.com', brand: 'BCS' },
    ],
  },
  {
    district: 'Begusarai',
    hindi: 'बेगूसराय',
    count: 4,
    color: '#e8762e',
    mapPos: { top: '49%', left: '58%' },
    dealers: [
      { name: 'SATHI ENTERPRISES', stars: 4, address: 'Harrakh, Begusarai', phone: '+91 9876543227', email: 'sathi@example.com', brand: 'BCS' },
      { name: 'Jai Govind Enterprises', stars: 4, address: 'Begusarai', phone: '+91 9771197411', email: 'jaigovind@example.com', brand: 'Shaktiman' },
      { name: 'MOLTRIX GANGA AGRO', stars: 4, address: 'Begusarai', phone: '+91 8877689763', email: 'moltrix@example.com', brand: 'Shaktiman' },
      { name: 'MONU AUTOKING', stars: 4, address: 'Begusarai', phone: '+91 9876543260', email: 'monuautoking@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Madhepura',
    hindi: 'मधेपुरा',
    count: 2,
    color: '#fbc02d',
    mapPos: { top: '40%', left: '66%' },
    dealers: [
      { name: 'JAY BABA AGRICULTURE WORKS', stars: 4, address: 'Main Road, Madhepura', phone: '+91 9876543228', email: 'jaybaba@example.com', brand: 'BCS' },
      { name: 'Maa yashoda Agri Impliment', stars: 4, address: 'Murliganj, Madhepura', phone: '+91 7545808034', email: 'maayashoda@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Saharsa',
    hindi: 'सहरसा',
    count: 2,
    color: '#3b82f6',
    mapPos: { top: '39%', left: '64%' },
    dealers: [
      { name: 'RAJ MACHINERY STORES', stars: 4, address: 'Bari Bazar, Saharsa', phone: '+91 9876543229', email: 'rajmachinery@example.com', brand: 'BCS' },
      { name: 'Chandrika Agro Impliments', stars: 4, address: 'Saharsa', phone: '+91 9262612473', email: 'chandrikaagro@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Patna',
    hindi: 'पटना',
    count: 1,
    color: '#8b5cf6',
    mapPos: { top: '48%', left: '43%' },
    dealers: [
      { name: 'HANS ENTERPRISES', stars: 5, address: 'Exhibition Road, Patna', phone: '+91 9876543230', email: 'hans@example.com', brand: 'BCS' },
    ],
  },

  {
    district: 'Gaya',
    hindi: 'गया',
    count: 1,
    color: '#e8762e',
    mapPos: { top: '52%', left: '42%' },
    dealers: [
      { name: 'MAA SHAKTI AGRO', stars: 4, address: 'GB Road, Gaya', phone: '+91 9876543232', email: 'maashakti@example.com', brand: 'BCS' },
    ],
  },
  {
    district: 'Purnea',
    hindi: 'पूर्णिया',
    count: 1,
    color: '#3b82f6',
    mapPos: { top: '42%', left: '72%' },
    dealers: [
      { name: 'Alam Agriculture', stars: 4, address: 'Purnea', phone: '+91 9973217178', email: 'alamagri@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Araria',
    hindi: 'अररिया',
    count: 2,
    color: '#8b5cf6',
    mapPos: { top: '35%', left: '70%' },
    dealers: [
      { name: 'ALAM ENTERPRISES', stars: 4, address: 'Araria', phone: '+91 8809026493', email: 'alamenterprises@example.com', brand: 'Shaktiman' },
      { name: 'RADHA KRISHNA AGRICO', stars: 4, address: 'Araria', phone: '+91 6203011366', email: 'radhakrishna@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Ekma',
    hindi: 'एकमा',
    count: 1,
    color: '#4ba242',
    mapPos: { top: '44%', left: '36%' },
    dealers: [
      { name: 'Anand Agro', stars: 4, address: 'Ekma', phone: '+91 9507833605', email: 'anandagro@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Barharia',
    hindi: 'बड़हरिया',
    count: 1,
    color: '#e8762e',
    mapPos: { top: '40%', left: '36%' },
    dealers: [
      { name: 'Bihar Krishi Yantra', stars: 4, address: 'Barharia', phone: '+91 9876543238', email: 'biharkrishi@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Kishanganj',
    hindi: 'किशनगंज',
    count: 1,
    color: '#fbc02d',
    mapPos: { top: '36%', left: '76%' },
    dealers: [
      { name: 'Chakarwarti Trading Company', stars: 4, address: 'Kishanganj', phone: '+91 6206308869', email: 'chakarwarti@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Sonbarsa',
    hindi: 'सोनबरसा',
    count: 1,
    color: '#3b82f6',
    mapPos: { top: '42%', left: '60%' },
    dealers: [
      { name: 'Chandan & Company', stars: 4, address: 'Sonbarsa', phone: '+91 7257845319', email: 'chandan@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Tajpur',
    hindi: 'ताजपुर',
    count: 1,
    color: '#8b5cf6',
    mapPos: { top: '47%', left: '50%' },
    dealers: [
      { name: 'Ganpati Enterprises', stars: 4, address: 'Tajpur', phone: '+91 8002613029', email: 'ganpati@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Marhora',
    hindi: 'मढ़ौरा',
    count: 1,
    color: '#4ba242',
    mapPos: { top: '45%', left: '38%' },
    dealers: [
      { name: 'Gayatri Enterprises', stars: 4, address: 'Marhora', phone: '+91 9931496172', email: 'gayatri@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Raxaul',
    hindi: 'रक्सौल',
    count: 1,
    color: '#e8762e',
    mapPos: { top: '28%', left: '41%' },
    dealers: [
      { name: 'GOLDY ENTERPRISES', stars: 4, address: 'Raxaul', phone: '+91 9122251100', email: 'goldy@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Katihar',
    hindi: 'कटिहार',
    count: 1,
    color: '#fbc02d',
    mapPos: { top: '49%', left: '72%' },
    dealers: [
      { name: 'Jai Kisan Agro', stars: 4, address: 'Katihar', phone: '+91 9546353315', email: 'jaikisan@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Bettiah',
    hindi: 'बेतिया',
    count: 1,
    color: '#3b82f6',
    mapPos: { top: '32%', left: '38%' },
    dealers: [
      { name: 'Keshanji Motors', stars: 4, address: 'Bettiah', phone: '+91 9939912872', email: 'keshanji@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Harinagar',
    hindi: 'हरिनगर',
    count: 1,
    color: '#8b5cf6',
    mapPos: { top: '28%', left: '34%' },
    dealers: [
      { name: 'Krishi Vikash Kendra', stars: 4, address: 'Harinagar', phone: '+91 9430824241', email: 'krishivikash@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Benipur',
    hindi: 'बेनीपुर',
    count: 1,
    color: '#4ba242',
    mapPos: { top: '39%', left: '55%' },
    dealers: [
      { name: 'KRISHNA ENTERPRISES', stars: 4, address: 'Benipur', phone: '+91 9470194861', email: 'krishnaent@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Khutauna',
    hindi: 'खुटौना',
    count: 1,
    color: '#e8762e',
    mapPos: { top: '30%', left: '56%' },
    dealers: [
      { name: 'Laxmi Automobile', stars: 4, address: 'Khutauna', phone: '+91 9876543252', email: 'laxmiauto@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Samastipur',
    hindi: 'समस्तीपुर',
    count: 1,
    color: '#fbc02d',
    mapPos: { top: '46%', left: '51%' },
    dealers: [
      { name: 'Maa Bhagwati Kisan Sewa Kendra', stars: 4, address: 'Samastipur', phone: '+91 9534454854', email: 'maabhagwati@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Hathauri',
    hindi: 'हथौड़ी',
    count: 1,
    color: '#3b82f6',
    mapPos: { top: '40%', left: '48%' },
    dealers: [
      { name: 'MAHALAXMI TRADERS', stars: 4, address: 'Hathauri', phone: '+91 993147691', email: 'mahalaxmi@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Jaynagar',
    hindi: 'जयनगर',
    count: 1,
    color: '#8b5cf6',
    mapPos: { top: '28%', left: '54%' },
    dealers: [
      { name: 'Mahesh Machinery', stars: 4, address: 'Jaynagar', phone: '+91 9876543257', email: 'maheshmachinery@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Supaul',
    hindi: 'सुपौल',
    count: 1,
    color: '#4ba242',
    mapPos: { top: '35%', left: '62%' },
    dealers: [
      { name: 'Manish kumar', stars: 4, address: 'Supaul', phone: '+91 7903547201', email: 'manishkumar@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Ranchi',
    hindi: 'रांची',
    count: 1,
    color: '#e8762e',
    mapPos: { top: '85%', left: '45%' },
    dealers: [
      { name: 'N B ENTERPRISES', stars: 4, address: 'Ranchi', phone: '+91 9876543261', email: 'nbenterprises@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Mainatad',
    hindi: 'मैनाटांड़',
    count: 1,
    color: '#fbc02d',
    mapPos: { top: '26%', left: '36%' },
    dealers: [
      { name: 'Narayan Machinery', stars: 4, address: 'Mainatad', phone: '+91 9631836909', email: 'narayanmach@example.com', brand: 'Shaktiman' }
    ],
  },
  {
    district: 'Seohar',
    hindi: 'शिवहर',
    count: 1,
    color: '#3b82f6',
    mapPos: { top: '34%', left: '45%' },
    dealers: [
      { name: 'New Anand Spare Parts', stars: 4, address: 'Seohar', phone: '+91 9876543263', email: 'newanand@example.com', brand: 'Shaktiman' }
    ],
  },
];

const StarRating = ({ count }) => (
  <div className="star-rating">
    {[1,2,3,4,5].map(s => (
      <svg key={s} width="14" height="14" viewBox="0 0 24 24"
        fill={s <= count ? '#fbc02d' : 'none'}
        stroke={s <= count ? '#fbc02d' : '#ddd'}
        strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
      </svg>
    ))}
  </div>
);

const DealerCard = ({ d }) => (
  <div className="dealer-list-item" style={{ marginBottom: '15px' }}>
    <div className="dealer-list-left">
      <div className="dealer-list-icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e8762e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
          <polyline points="9 22 9 12 15 12 15 22"></polyline>
        </svg>
      </div>
      <div className="dealer-list-details">
        {d.brand && <span className={`brand-dealer-badge brand-${d.brand.toLowerCase()}`} style={{ marginBottom: '6px' }}>{d.brand} Dealer</span>}
        <h4 className="dealer-list-name" style={{ whiteSpace: 'pre-line' }}>{d.name}</h4>
        <StarRating count={d.stars} />
        <div className="dealer-list-meta">
          <span>
            {d.address}
          </span>
          <span style={{ display: 'flex', alignItems: 'flex-start', gap: '4px' }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#e8762e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginTop: '3px' }}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l2.27-2.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
            <span style={{ whiteSpace: 'pre-line', lineHeight: '1.4' }}>{d.phone}</span>
          </span>
          <span>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#e8762e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
            {d.email}
          </span>
        </div>
      </div>
    </div>
    <div className="dealer-list-actions">
      <button className="btn-dl-call" onClick={() => window.open(`tel:${d.phone.split('\n')[0].replace(/[^0-9+]/g, '')}`)}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight:'5px'}}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l2.27-2.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
        Call
      </button>
      <button className="btn-dl-chat" onClick={() => window.open(`https://wa.me/${d.phone.split('\n')[0].replace(/[^0-9]/g, '')}`, '_blank')}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style={{marginRight:'5px'}}><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.438 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.414 0 .004 5.412 0 12.046c0 2.123.555 4.195 1.608 6.014L0 24l6.117-1.605a11.782 11.782 0 005.925 1.587h.005c6.632 0 12.043-5.414 12.047-12.048a11.821 11.821 0 00-3.526-8.513"/></svg>
        Chat
      </button>
    </div>
  </div>
);

const DealerLocatorPage = () => {
  const { t, i18n } = useTranslation();
  const [dealersData, setDealersData] = useState(DEALERS_DATA);
  const [selectedDistrict, setSelectedDistrict] = useState('Muzaffarpur');
  const [selectedSupport, setSelectedSupport] = useState(null);
  const [formData, setFormData] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const isLocalHost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const envApiUrl = process.env.REACT_APP_API_URL?.trim();
  const API_URL = envApiUrl && (isLocalHost || (!envApiUrl.includes("localhost") && !envApiUrl.includes("127.0.0.1"))) ? envApiUrl : '/api';

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const openSupportParam = params.get('openSupport') || params.get('support');
    if (openSupportParam) {
      const paramLower = openSupportParam.toLowerCase();
      if (paramLower === 'parts orders' || paramLower === 'parts' || paramLower === 'sprayer parts') {
        setSelectedSupport('Parts Orders');
      }
    }
  }, []);

  useEffect(() => {
    const fetchDealers = async () => {
      try {
        const res = await fetch(`${API_URL}/dealers`);
        const json = await res.json();
        if (json.success && json.data) {
          const grouped = {};
          
          // Pre-populate with all static districts to ensure map pins and accordion entries are preserved
          DEALERS_DATA.forEach(d => {
            grouped[d.district] = {
              district: d.district,
              hindi: d.hindi,
              color: d.color,
              mapPos: d.mapPos,
              dealers: []
            };
          });

          json.data.forEach(dealer => {
            if (!dealer.isAvailable) return;
            const dist = dealer.district;
            
            // Case-insensitive check to map to existing static districts
            let matchedKey = Object.keys(grouped).find(k => k.toLowerCase() === dist.trim().toLowerCase());
            
            if (!matchedKey) {
              grouped[dist] = {
                district: dist,
                hindi: dist,
                color: '#3b82f6',
                mapPos: { top: '50%', left: '50%' },
                dealers: []
              };
              matchedKey = dist;
            }
            
            grouped[matchedKey].dealers.push({
              name: dealer.name,
              stars: dealer.rating || 4,
              address: dealer.address,
              phone: dealer.phone,
              email: dealer.email || '',
              brand: dealer.brand || 'Shaktiman'
            });
          });
          
          const finalArr = Object.values(grouped).map(d => ({
            ...d,
            count: d.dealers.length
          }));
          
          setDealersData(finalArr);
        }
      } catch (err) {
        console.error("Failed to load dealers: ", err);
      }
    };
    fetchDealers();
  }, [API_URL]);

  useEffect(() => {
    if (containerRef.current) {
      // Small timeout to allow the expanded accordion height/layout to settle
      setTimeout(() => {
        const activeEl = containerRef.current.querySelector('.district-list-row.active');
        if (activeEl) {
          const containerRect = containerRef.current.getBoundingClientRect();
          const activeRect = activeEl.getBoundingClientRect();
          const relativeTop = activeRect.top - containerRect.top + containerRef.current.scrollTop;
          
          containerRef.current.scrollTo({
            top: relativeTop,
            behavior: 'smooth'
          });
        }
      }, 150);
    }
  }, [selectedDistrict]);

  const [zoom, setZoom] = useState(3.6);
  const [pan, setPan] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

  const tZoom = (zoom - 1) / (3.6 - 1 || 1);
  const Cx = 0.5 + (0.61 - 0.5) * tZoom;
  const Cy = 0.5 + (0.42 - 0.5) * tZoom;

  const finalCx = Cx + pan.x;
  const finalCy = Cy + pan.y;

  const getDotPosition = (mapPos, district) => {
    const leftVal = parseFloat(mapPos.left) / 100;
    const topVal = parseFloat(mapPos.top) / 100;
    const origX = 0.61 + (leftVal - 0.5) / 3.6;
    const origY = 0.42 + (topVal - 0.5) / 3.6;

    const currentLeft = (0.5 + zoom * (origX - finalCx)) * 100;
    const currentTop = (0.5 + zoom * (origY - finalCy)) * 100;

    return {
      left: `${currentLeft}%`,
      top: `${currentTop}%`,
    };
  };

  const handleDragStart = (clientX, clientY) => {
    setIsDragging(true);
    setDragStart({ x: clientX, y: clientY });
  };

  const handleDragMove = (clientX, clientY) => {
    if (!isDragging) return;
    const deltaX = clientX - dragStart.x;
    const deltaY = clientY - dragStart.y;

    // Convert pixel offset to coordinate delta (based on 550px viewport)
    const shiftX = -deltaX / (550 * zoom);
    const shiftY = -deltaY / (550 * zoom);

    setPan(prev => ({
      x: prev.x + shiftX,
      y: prev.y + shiftY
    }));
    setDragStart({ x: clientX, y: clientY });
  };

  const handleDragEnd = () => {
    setIsDragging(false);
  };

  const handleSelectDistrict = (district) => {
    setSelectedDistrict(district);
    setPan({ x: 0, y: 0 }); // Reset panning offset
    setZoom(3.6);
  };


  const SUPPORT_FORMS = useMemo(() => ({
    'Stock Requests': {
      title: 'Stock Request',
      desc: 'Submit a request for product stock replenishment from Kisaan Maan.',
      color: '#4ba242',
      fields: [
        { label: 'Dealer Name', type: 'text', placeholder: 'Your dealership name' },
        { label: 'District', type: 'select', options: ['Muzaffarpur','Vaishali','Sitamarhi','East Champaran','West Champaran'] },
        { label: 'Product Category', type: 'select', options: ['Rotavators','Power Tillers','Tractors','Sprayers','Seed Drills','Spare Parts'] },
        { label: 'Quantity Required', type: 'number', placeholder: 'e.g. 5' },
        { label: 'Required By Date', type: 'date', placeholder: '' },
        { label: 'Additional Notes', type: 'textarea', placeholder: 'Any specific model or specification...' },
      ],
    },
    'Parts Orders': {
      title: 'Parts Order',
      desc: 'Order genuine spare parts directly from Kisaan Maan warehouse.',
      color: '#e8762e',
      fields: [
        { label: 'Dealer Name', type: 'text', placeholder: 'Your dealership name' },
        { label: 'Contact Number', type: 'tel', placeholder: '+91 XXXXXXXXXX' },
        { label: 'Part Name / Part Number', type: 'select', options: ['Rotavator Blade (RTV-BL-01)', 'Disc Harrow Blade (DH-BL-02)', 'Cultivator Tyne (CUL-TY-03)', 'MB Plough Shear (PL-SH-04)', 'Drive Shaft (DS-05)', 'Main Gearbox Assembly (GB-06)', 'Other / Not Listed'] },
        { label: 'Quantity', type: 'number', placeholder: 'e.g. 10' },
        { label: 'Compatible Machine Model', type: 'select', options: ['Rotavator Standard 6FT', 'Rotavator Premium 7FT', 'MB Plough 3 Bottom', 'Disc Harrow 20 Disc', 'Disc Harrow 22 Disc', 'Cultivator 9 Tyne', 'Power Tiller 15HP', 'Other / Custom Model'] },
        { label: 'Delivery Address', type: 'textarea', placeholder: 'Full delivery address...' },
      ],
    },
    'Marketing Help': {
      title: 'Marketing Help',
      desc: 'Request marketing materials, banners, brochures, or campaign support.',
      color: '#fbc02d',
      fields: [
        { label: 'Dealer Name', type: 'text', placeholder: 'Your dealership name' },
        { label: 'Contact Person', type: 'text', placeholder: 'Your name' },
        { label: 'Type of Support', type: 'select', options: ['Brochures & Pamphlets','Banners & Hoardings','Digital Marketing Assets','Demo Equipment','Event Support','Other'] },
        { label: 'Target Area / Village', type: 'text', placeholder: 'e.g. Hajipur, Vaishali district' },
        { label: 'Preferred Timeline', type: 'text', placeholder: 'e.g. Before Rabi season (Oct)' },
        { label: 'Details / Requirements', type: 'textarea', placeholder: 'Describe your marketing need...' },
      ],
    },
    'Technical Support': {
      title: 'Technical Support',
      desc: 'Get technical assistance for product issues, servicing, or installation queries.',
      color: '#3b82f6',
      fields: [
        { label: 'Dealer Name', type: 'text', placeholder: 'Your dealership name' },
        { label: 'Contact Number', type: 'tel', placeholder: '+91 XXXXXXXXXX' },
        { label: 'Product / Machine', type: 'text', placeholder: 'e.g. BCS Power Tiller 45HP' },
        { label: 'Issue Type', type: 'select', options: ['Installation Help','Repair / Breakdown','Spare Part Identification','Warranty Claim','Training Request','Other'] },
        { label: 'Serial Number (if available)', type: 'text', placeholder: 'e.g. SN-2024-BCS-001' },
        { label: 'Issue Description', type: 'textarea', placeholder: 'Describe the problem in detail...' },
      ],
    },
  }), []);

  // openSupport function removed because Dealer Support card was deleted

  const closeSupport = () => {
    setSelectedSupport(null);
    setSubmitted(false);
    setFormData({});
  };

  const handleFormChange = (label, value) => {
    setFormData(prev => ({ ...prev, [label]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Map human-readable labels to backend schema fields
    const labelToFieldMap = {
      'Dealer Name': 'dealerName',
      'District': 'district',
      'Product Category': 'productCategory',
      'Quantity Required': 'quantityRequired',
      'Required By Date': 'requiredByDate',
      'Additional Notes': 'additionalNotes',
      'Contact Number': 'contactNumber',
      'Part Name / Part Number': 'partNameOrNumber',
      'Quantity': 'quantity',
      'Compatible Machine Model': 'machineModel',
      'Delivery Address': 'deliveryAddress',
      'Contact Person': 'contactPerson',
      'Type of Support': 'typeOfSupport',
      'Target Area / Village': 'targetArea',
      'Preferred Timeline': 'preferredTimeline',
      'Details / Requirements': 'details',
      'Product / Machine': 'productMachine',
      'Issue Type': 'issueType',
      'Serial Number (if available)': 'serialNumber',
      'Issue Description': 'issueDescription',
    };

    const payload = {
      requestType: selectedSupport
    };

    Object.keys(formData).forEach(label => {
      if (labelToFieldMap[label]) {
        payload[labelToFieldMap[label]] = formData[label];
      }
    });

    try {
      const response = await fetch(`${API_URL}/dealer-support`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
      
      if (response.ok) {
        setSubmitted(true);
      } else {
        alert('Failed to submit request. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting dealer support request:', error);
      alert('Network error. Please try again later.');
    }
  };

  return (
    <div className="dealer-page">
      <Header />

      {/* Hero Banner */}
      <section className="dealer-hero">
        <div className="container">
          <div className="dealer-hero-tag">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
            {t('dealer_locator.hero_tag')}
          </div>
          <h1 className="dealer-hero-title">{t('dealer_locator.hero_title')}</h1>
          <p className="dealer-hero-sub">{t('dealer_locator.hero_sub')}</p>
          <div className="dealer-hero-stats">
            <div className="hero-stat">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
              <strong>250+</strong><span>{t('dealer_locator.stats.dealers')}</span>
            </div>
            <div className="hero-stat">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
              <strong>38</strong><span>{t('dealer_locator.stats.districts')}</span>
            </div>
            <div className="hero-stat">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s-8-4.5-8-11.8A8 8 0 0 1 12 2a8 8 0 0 1 8 8.2c0 7.3-8 11.8-8 11.8z"></path><circle cx="12" cy="10" r="3"></circle></svg>
              <strong>100%</strong><span>{t('dealer_locator.stats.parts')}</span>
            </div>
            <div className="hero-stat">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>
              <strong>58+</strong><span>{t('dealer_locator.stats.years')}</span>
            </div>
          </div>
        </div>
      </section>

      {/* Our Presence in Bihar */}
      <section className="bihar-presence">
        <div className="container">
          <div className="presence-card">

            {/* Header row */}
            <div className="presence-header">
              <div>
                <h2 className="presence-title">{t('dealer_locator.presence_title')}</h2>
                <p className="presence-sub">{t('dealer_locator.presence_sub')}</p>
              </div>
              <div className="presence-district-pills">
                {dealersData.map((d) => (
                  <button
                    key={d.district}
                    className={`presence-pill ${selectedDistrict === d.district ? 'active' : ''}`}
                    onClick={() => handleSelectDistrict(d.district)}
                    style={{
                      borderColor: selectedDistrict === d.district ? d.color : `${d.color}60`,
                      color: selectedDistrict === d.district ? 'white' : d.color,
                      backgroundColor: selectedDistrict === d.district ? d.color : 'transparent'
                    }}
                  >
                    {i18n.language === 'hi' ? d.hindi : d.district}
                  </button>
                ))}
              </div>
            </div>

            {/* Map + District list */}
            <div className="presence-body">
              {/* Map */}
              <div 
                className="map-wrap" 
                style={{ position: 'relative', cursor: isDragging ? 'grabbing' : 'grab', userSelect: 'none' }}
                onMouseDown={(e) => handleDragStart(e.clientX, e.clientY)}
                onMouseMove={(e) => handleDragMove(e.clientX, e.clientY)}
                onMouseUp={handleDragEnd}
                onMouseLeave={handleDragEnd}
                onTouchStart={(e) => {
                  if (e.touches.length === 1) {
                    handleDragStart(e.touches[0].clientX, e.touches[0].clientY);
                  }
                }}
                onTouchMove={(e) => {
                  if (e.touches.length === 1) {
                    handleDragMove(e.touches[0].clientX, e.touches[0].clientY);
                  }
                }}
                onTouchEnd={handleDragEnd}
              >
                <div
                  className="india-map-img"
                  style={{
                    backgroundImage: `url(${indiaMap})`,
                    backgroundColor: 'lightgray',
                    backgroundPosition: `${finalCx * 100}% ${finalCy * 100}%`,
                    backgroundSize: `${zoom * 100}%`,
                    backgroundRepeat: 'no-repeat',
                    width: '550px',
                    height: '550px',
                    maxWidth: '100%',
                    aspectRatio: '1 / 1',
                    transition: isDragging ? 'none' : 'background-position 0.5s cubic-bezier(0.25, 1, 0.5, 1), background-size 0.5s cubic-bezier(0.25, 1, 0.5, 1)',
                    pointerEvents: 'none'
                  }}
                />
                
                {dealersData.map((d, idx) => {
                  const dotPos = getDotPosition(d.mapPos, d.district);
                  return (
                    <div
                      key={idx}
                      className={`map-dealer-dot ${selectedDistrict === d.district ? 'active' : ''}`}
                      style={{
                        position: 'absolute',
                        top: dotPos.top,
                        left: dotPos.left,
                        width: selectedDistrict === d.district ? '14px' : '9px',
                        height: selectedDistrict === d.district ? '14px' : '9px',
                        backgroundColor: d.color,
                        borderRadius: '50%',
                        border: '2px solid white',
                        cursor: 'pointer',
                        transform: 'translate(-50%, -50%)',
                        boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
                        transition: isDragging ? 'none' : 'all 0.5s cubic-bezier(0.25, 1, 0.5, 1)',
                        zIndex: selectedDistrict === d.district ? 10 : 2,
                      }}
                      onClick={() => handleSelectDistrict(d.district)}
                      title={d.district}
                    >
                      {selectedDistrict === d.district && (
                        <span className="dot-pulse" style={{
                          position: 'absolute',
                          top: '-4px',
                          left: '-4px',
                          right: '-4px',
                          bottom: '-4px',
                          borderRadius: '50%',
                          border: `2px solid ${d.color}`,
                          animation: 'mapPulse 1.5s infinite ease-in-out',
                          pointerEvents: 'none'
                        }}></span>
                      )}

                      {/* District / City Name Label */}
                      <span 
                        className="map-dot-label" 
                        data-selected={selectedDistrict === d.district ? 'true' : 'false'}
                        data-zoom-visible={zoom > 2.5 ? 'true' : 'false'}
                        data-zoom-deep={zoom > 4.5 ? 'true' : 'false'}
                        style={{
                          position: 'absolute',
                          left: '18px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          whiteSpace: 'nowrap',
                          fontSize: '11px',
                          fontWeight: '700',
                          color: selectedDistrict === d.district ? '#2e7d28' : '#333',
                          textShadow: '0 0 4px #fff, 0 0 4px #fff, 0 0 4px #fff',
                          transition: 'opacity 0.3s ease, color 0.3s ease',
                          pointerEvents: 'none',
                          background: 'rgba(255, 255, 255, 0.85)',
                          padding: '3px 8px',
                          borderRadius: '4px',
                          boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                          border: selectedDistrict === d.district ? '1px solid #2e7d28' : '1px solid #e0e0e0',
                        }}
                      >
                        {i18n.language === 'hi' ? d.hindi : d.district}
                      </span>
                    </div>
                  );
                })}

                {/* Floating zoom controls */}
                <div className="map-zoom-controls" style={{
                  position: 'absolute',
                  bottom: '80px',
                  right: '25px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                  zIndex: 20
                }}>
                  <button 
                    onClick={() => setZoom(z => Math.min(6, z + 0.5))} 
                    style={{
                      width: '36px',
                      height: '36px',
                      borderRadius: '50%',
                      border: 'none',
                      backgroundColor: 'rgba(255, 255, 255, 0.95)',
                      color: '#2e7d28',
                      fontSize: '20px',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                      transition: 'all 0.2s',
                    }}
                    title="Zoom In"
                  >
                    +
                  </button>
                  <button 
                    onClick={() => setZoom(z => Math.max(1, z - 0.5))} 
                    style={{
                      width: '36px',
                      height: '36px',
                      borderRadius: '50%',
                      border: 'none',
                      backgroundColor: 'rgba(255, 255, 255, 0.95)',
                      color: '#2e7d28',
                      fontSize: '20px',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                      transition: 'all 0.2s',
                    }}
                    title="Zoom Out"
                  >
                    -
                  </button>
                  <button 
                    onClick={() => setZoom(zoom > 2 ? 1 : 3.6)} 
                    style={{
                      padding: '6px 14px',
                      borderRadius: '20px',
                      border: 'none',
                      backgroundColor: 'rgba(255, 255, 255, 0.95)',
                      color: '#2e7d28',
                      fontSize: '11px',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                      transition: 'all 0.2s',
                      whiteSpace: 'nowrap'
                    }}
                    title="Toggle India / Bihar view"
                  >
                    {zoom > 2 ? 'Show India' : 'Zoom Bihar'}
                  </button>
                </div>

                <div className="bihar-popup" style={{ top: '88%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                  <div className="popup-dots">
                    <span className="pop-dot green"></span>
                    <span className="pop-dot orange"></span>
                    <span className="pop-dot orange"></span>
                  </div>
                  <div className="popup-text">
                    <strong>{t('dealer_locator.map.title')}</strong>
                    <span>{t('dealer_locator.map.sub')}</span>
                  </div>
                </div>
              </div>

              {/* District List with Legend */}
              <div className="district-list" ref={containerRef}>
                {dealersData.map((d, index) => (
                  <div
                    key={index}
                    className={`district-list-row ${selectedDistrict === d.district ? 'active' : ''}`}
                    onClick={() => handleSelectDistrict(d.district)}
                    style={{ flexDirection: 'column', alignItems: 'stretch' }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '14px', width: '100%' }}>
                      <span className="district-dot" style={{ backgroundColor: d.color }}></span>
                      <div className="district-list-info" style={{ flex: 1, textAlign: 'left' }}>
                        <span className="district-list-name">{i18n.language === 'hi' ? d.hindi : d.district}</span>
                        <span className="district-list-hindi">{i18n.language === 'hi' ? d.district : d.hindi}</span>
                      </div>
                      <span className="district-list-count" style={{ color: d.color }}>
                        {d.count} {t('dealer_locator.map.dealers_count')}
                      </span>
                    </div>

                    {selectedDistrict === d.district && (
                      <div 
                        className="district-dealers-inline" 
                        style={{ 
                          marginTop: '12px', 
                          paddingLeft: '28px', 
                          display: 'flex', 
                          flexDirection: 'column', 
                          gap: '10px',
                          borderTop: '1.5px dashed #e2e8f0',
                          paddingTop: '12px'
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        {d.dealers.map((dealer, di) => (
                          <div key={di} className="inline-dealer-item" style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                             {dealer.brand && <span className={`brand-dealer-badge-small brand-${dealer.brand.toLowerCase()}`} style={{ marginBottom: '4px' }}>{dealer.brand} Dealer</span>}
                             <div style={{ fontWeight: '700', fontSize: '14px', color: '#1a1a1a', whiteSpace: 'pre-line' }}>{dealer.name}</div>
                            {dealer.address && (
                              <div style={{ fontSize: '12px', color: '#666', marginTop: '2px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                                {dealer.address}
                              </div>
                            )}
                            {dealer.phone && (
                              <div style={{ fontSize: '12px', color: '#666', marginTop: '1px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l2.27-2.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                                <span style={{ whiteSpace: 'pre-line' }}>{dealer.phone}</span>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ))}

                {/* Legend */}
                <div className="map-legend">
                  <div className="legend-title">{t('dealer_locator.legend.title')}</div>
                  <div className="legend-item">
                    <div className="legend-box border-green"></div>
                    <span>{t('dealer_locator.legend.highlighted')}</span>
                  </div>
                  <div className="legend-item">
                    <div className="legend-dot orange"></div>
                    <span>{t('dealer_locator.legend.dealer_loc')}</span>
                  </div>
                  <div className="legend-item">
                    <div className="legend-line"></div>
                    <span>{t('dealer_locator.legend.river')}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Apply button */}
            <div className="become-dealer-btn" onClick={() => navigate('/apply', { state: { fromDealerLocator: true } })} style={{ cursor: 'pointer' }}>
              <svg width="15.989" height="15.989" viewBox="0 0 16 16" fill="none" style={{marginRight: '6px', flexShrink: 0}}>
                <g clipPath="url(#clip_dealer_btn)">
                  <path d="M7.32812 11.3253L8.66052 12.6577C8.79175 12.7889 8.94754 12.893 9.119 12.9641C9.29046 13.0351 9.47422 13.0716 9.65981 13.0716C9.8454 13.0716 10.0292 13.0351 10.2006 12.9641C10.3721 12.893 10.5279 12.7889 10.6591 12.6577C10.7903 12.5265 10.8944 12.3707 10.9655 12.1992C11.0365 12.0278 11.073 11.844 11.073 11.6584C11.073 11.4728 11.0365 11.2891 10.9655 11.1176C10.8944 10.9461 10.7903 10.7903 10.6591 10.6591" stroke="white" strokeWidth="1.33239" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M9.32622 9.32672L10.9917 10.9922C11.2567 11.2572 11.6162 11.4061 11.991 11.4061C12.3658 11.4061 12.7253 11.2572 12.9903 10.9922C13.2553 10.7272 13.4042 10.3677 13.4042 9.99292C13.4042 9.61811 13.2553 9.25865 12.9903 8.99362L10.4055 6.40878C10.0307 6.03451 9.52275 5.82429 8.99313 5.82429C8.4635 5.82429 7.95553 6.03451 7.58079 6.40878L6.99454 6.99503C6.72951 7.26006 6.37005 7.40896 5.99525 7.40896C5.62044 7.40896 5.26098 7.26006 4.99595 6.99503C4.73092 6.73 4.58203 6.37055 4.58203 5.99574C4.58203 5.62093 4.73092 5.26148 4.99595 4.99645L6.86796 3.12444C7.47569 2.51829 8.26824 2.13217 9.12013 2.02719C9.97203 1.92222 10.8346 2.10438 11.5713 2.54485L11.8844 2.73138C12.1681 2.90258 12.5053 2.96196 12.8304 2.89793L13.9896 2.66476" stroke="white" strokeWidth="1.33239" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M13.9904 1.9986L14.6566 9.32675H13.3242" stroke="white" strokeWidth="1.33239" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M1.99823 1.9986L1.33203 9.32675L5.6623 13.657C5.92733 13.9221 6.28679 14.0709 6.6616 14.0709C7.03641 14.0709 7.39586 13.9221 7.66089 13.657C7.92592 13.392 8.07481 13.0325 8.07481 12.6577C8.07481 12.2829 7.92592 11.9235 7.66089 11.6584" stroke="white" strokeWidth="1.33239" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M1.99805 2.66479H7.32761" stroke="white" strokeWidth="1.33239" strokeLinecap="round" strokeLinejoin="round"/>
                </g>
                <defs>
                  <clipPath id="clip_dealer_btn">
                    <rect width="15.9887" height="15.9887" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
              {t('dealer_locator.become_dealer.btn')}
            </div>

            {/* WA Float */}
            <div className="wa-float-btn" onClick={() => window.open('https://wa.me/919631277264', '_blank')} style={{ cursor: 'pointer' }}>
              <svg viewBox="0 0 24 24" width="24" height="24" fill="white">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.438 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.414 0 .004 5.412 0 12.046c0 2.123.555 4.195 1.608 6.014L0 24l6.117-1.605a11.782 11.782 0 005.925 1.587h.005c6.632 0 12.043-5.414 12.047-12.048a11.821 11.821 0 00-3.526-8.513"/>
              </svg>
            </div>

          </div>
        </div>
      </section>

      {/* Dealer CTA Cards */}
      <section className="dealer-cta-section">
        <div className="container">
          <div className="dealer-cta-grid">

            {/* Left — Become a Dealer */}
            <div className="cta-card become-dealer-card">
              <div className="cta-card-decor"></div>
              <div className="cta-card-icon">
                <svg width="23.992" height="23.992" viewBox="0 0 24 24" fill="none" style={{flexShrink: 0}}>
                  <path d="M10.9961 16.9944L12.9954 18.9938C13.1924 19.1907 13.4261 19.3469 13.6834 19.4535C13.9407 19.56 14.2165 19.6149 14.495 19.6149C14.7734 19.6149 15.0492 19.56 15.3065 19.4535C15.5638 19.3469 15.7975 19.1907 15.9945 18.9938C16.1914 18.7969 16.3476 18.5631 16.4542 18.3058C16.5607 18.0485 16.6156 17.7727 16.6156 17.4943C16.6156 17.2158 16.5607 16.94 16.4542 16.6827C16.3476 16.4254 16.1914 16.1917 15.9945 15.9948" stroke="white" strokeWidth="1.99935" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M13.995 13.9955L16.4942 16.4947C16.8919 16.8923 17.4313 17.1158 17.9937 17.1158C18.5561 17.1158 19.0955 16.8923 19.4932 16.4947C19.8909 16.097 20.1143 15.5576 20.1143 14.9951C20.1143 14.4327 19.8909 13.8933 19.4932 13.4956L15.6145 9.61689C15.0521 9.05527 14.2899 8.73981 13.4951 8.73981C12.7004 8.73981 11.9382 9.05527 11.3758 9.61689L10.4961 10.4966C10.0984 10.8943 9.55903 11.1177 8.99661 11.1177C8.43418 11.1177 7.89479 10.8943 7.49709 10.4966C7.0994 10.0989 6.87598 9.55951 6.87598 8.99709C6.87598 8.43466 7.0994 7.89527 7.49709 7.49758L10.3062 4.68849C11.2181 3.77893 12.4074 3.19953 13.6857 3.042C14.9641 2.88447 16.2584 3.15782 17.3639 3.81877L17.8337 4.09868C18.2594 4.35558 18.7655 4.44469 19.2533 4.3486L20.9927 3.99871" stroke="white" strokeWidth="1.99935" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M20.9928 2.99902L21.9925 13.9954H19.9932" stroke="white" strokeWidth="1.99935" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2.9987 2.99902L1.99902 13.9954L8.49691 20.4933C8.89461 20.891 9.434 21.1145 9.99642 21.1145C10.5589 21.1145 11.0982 20.891 11.4959 20.4933C11.8936 20.0956 12.1171 19.5562 12.1171 18.9938C12.1171 18.4314 11.8936 17.892 11.4959 17.4943" stroke="white" strokeWidth="1.99935" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2.99902 3.99866H10.9964" stroke="white" strokeWidth="1.99935" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h2 className="cta-card-title">{t('dealer_locator.become_dealer.title')}</h2>
              <p className="cta-card-desc">
                {t('dealer_locator.become_dealer.desc')}
              </p>
              <ul className="cta-features">
                {t('dealer_locator.become_dealer.features', { returnObjects: true }).map((f, i) => (
                  <li key={i}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.9)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="16 8 10 14 7 11"></polyline></svg>
                    {f}
                  </li>
                ))}
              </ul>
              <div className="cta-card-actions">
                <button className="cta-btn-primary white" onClick={() => navigate('/apply')}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight:'7px'}}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg>
                  {t('dealer_locator.become_dealer.apply_now')}
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginLeft:'auto'}}><polyline points="9 18 15 12 9 6"></polyline></svg>
                </button>
                <button className="cta-btn-outline-white" onClick={() => window.open('tel:+91 96312 77264', '_self')}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight:'7px'}}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l2.27-2.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                  {t('dealer_locator.become_dealer.call_us')}
                </button>
              </div>
            </div>

            {/* Removed Right — Dealer Support card as requested */}

          </div>
        </div>
      </section>

      {/* All Authorized Dealers Accordion Section */}
      <section className="all-dealers-section">
        <div className="container">
          <div className="all-dealers-header">
            <h2 className="all-dealers-title">{t('dealer_locator.all_dealers_title')}</h2>
            <p className="all-dealers-sub">{t('dealer_locator.all_dealers_sub')}</p>
          </div>

          {dealersData.map((dist) => {
            const isOpen = selectedDistrict === dist.district;
            return (
              <div key={dist.district} className="district-accordion">
                <div 
                  className="accordion-header" 
                  onClick={() => setSelectedDistrict(isOpen ? '' : dist.district)}
                >
                  <div className="accordion-left">
                    <div className="acc-icon" style={{ color: dist.color, backgroundColor: `${dist.color}15` }}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" />
                        <circle cx="12" cy="10" r="3" />
                      </svg>
                    </div>
                    <div className="acc-district-info" style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
                      <span className="acc-district" style={{ fontSize: '17px', fontWeight: '800', color: '#1a1a1a', display: 'flex', alignItems: 'center' }}>
                        {i18n.language === 'hi' ? dist.hindi : dist.district}
                        <span className="acc-hindi" style={{ marginLeft: '8px', fontSize: '13px', color: '#aaa', fontWeight: '400' }}>{i18n.language === 'hi' ? dist.district : dist.hindi}</span>
                      </span>
                      <span className="acc-subtitle" style={{ color: dist.color, fontSize: '13px', fontWeight: '600', marginTop: '2px', display: 'block' }}>
                        {dist.count} {t('dealer_locator.auth_dealers')}
                      </span>
                    </div>
                  </div>
                  <div className="accordion-right" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <span className="acc-count-badge" style={{ 
                      color: dist.color, 
                      backgroundColor: `${dist.color}15`,
                      padding: '4px 12px',
                      borderRadius: '50px',
                      fontSize: '12px',
                      fontWeight: '700',
                      textTransform: 'lowercase'
                    }}>
                      {dist.count} {t('dealer_locator.map.dealers_count')}
                    </span>
                    <div 
                      className="acc-arrow-circle" 
                      style={{ 
                        width: '32px',
                        height: '32px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: dist.color, 
                        backgroundColor: `${dist.color}15`,
                        transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.3s ease'
                      }}
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="6 9 12 15 18 9" />
                      </svg>
                    </div>
                  </div>
                </div>

                {isOpen && (
                  <div className="accordion-body">
                    {dist.dealers.map((d, di) => (
                      <DealerCard key={di} d={d} />
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </section>

      {/* No Dealer Near You Banner */}
      <section className="no-dealer-banner-section">
        <div className="container">
          <div className="no-dealer-banner">
            <div className="no-dealer-text">
              <h3 className="no-dealer-title">{t('dealer_locator.no_dealer_title')}</h3>
              <p className="no-dealer-sub">{t('dealer_locator.no_dealer_sub')}</p>
            </div>
            <div className="no-dealer-actions">
              <button className="btn-become-dealer-cta" onClick={() => navigate('/apply')}>
                <svg width="15.989" height="15.989" viewBox="0 0 16 16" fill="none" style={{marginRight: '7px', flexShrink: 0}}>
                  <g clipPath="url(#clip_banner_dealer)">
                    <path d="M7.32812 11.3254L8.66052 12.6578C8.79175 12.789 8.94754 12.8931 9.119 12.9641C9.29046 13.0351 9.47422 13.0717 9.65981 13.0717C9.8454 13.0717 10.0292 13.0351 10.2006 12.9641C10.3721 12.8931 10.5279 12.789 10.6591 12.6578C10.7903 12.5265 10.8944 12.3707 10.9655 12.1993C11.0365 12.0278 11.073 11.8441 11.073 11.6585C11.073 11.4729 11.0365 11.2891 10.9655 11.1177C10.8944 10.9462 10.7903 10.7904 10.6591 10.6592" stroke="white" strokeWidth="1.33239" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9.32622 9.32678L10.9917 10.9923C11.2567 11.2573 11.6162 11.4062 11.991 11.4062C12.3658 11.4062 12.7253 11.2573 12.9903 10.9923C13.2553 10.7272 13.4042 10.3678 13.4042 9.99298C13.4042 9.61817 13.2553 9.25871 12.9903 8.99368L10.4055 6.40884C10.0307 6.03457 9.52275 5.82435 8.99313 5.82435C8.4635 5.82435 7.95553 6.03457 7.58079 6.40884L6.99454 6.9951C6.72951 7.26012 6.37005 7.40902 5.99525 7.40902C5.62044 7.40902 5.26098 7.26012 4.99595 6.9951C4.73092 6.73007 4.58203 6.37061 4.58203 5.9958C4.58203 5.62099 4.73092 5.26154 4.99595 4.99651L6.86796 3.1245C7.47569 2.51836 8.26824 2.13223 9.12013 2.02725C9.97203 1.92228 10.8346 2.10444 11.5713 2.54491L11.8844 2.73144C12.1681 2.90265 12.5053 2.96202 12.8304 2.89799L13.9896 2.66482" stroke="white" strokeWidth="1.33239" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M13.9904 1.99854L14.6566 9.32669H13.3242" stroke="white" strokeWidth="1.33239" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M1.99823 1.99854L1.33203 9.32669L5.6623 13.657C5.92733 13.922 6.28679 14.0709 6.6616 14.0709C7.03641 14.0709 7.39586 13.922 7.66089 13.657C7.92592 13.3919 8.07481 13.0325 8.07481 12.6577C8.07481 12.2829 7.92592 11.9234 7.66089 11.6584" stroke="white" strokeWidth="1.33239" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M1.99805 2.66479H7.32761" stroke="white" strokeWidth="1.33239" strokeLinecap="round" strokeLinejoin="round"/>
                  </g>
                  <defs>
                    <clipPath id="clip_banner_dealer">
                      <rect width="15.9887" height="15.9887" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
                {t('dealer_locator.become_dealer.btn')}
              </button>
              <button className="btn-call-cta" onClick={() => window.open('tel:+91 96312 77264', '_self')}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight:'7px'}}>
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l2.27-2.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
                {t('dealer_locator.contact_us')}
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {/* ── Dealer Support Modal ── */}
      {selectedSupport && (() => {
        const form = SUPPORT_FORMS[selectedSupport];
        return (
          <div className="ds-modal-overlay" onClick={closeSupport}>
            <div className="ds-modal" onClick={e => e.stopPropagation()}>
              {/* Header */}
              <div className="ds-modal-header" style={{ borderTop: `4px solid ${form.color}` }}>
                <div>
                  <h2 className="ds-modal-title">{form.title}</h2>
                  <p className="ds-modal-desc">{form.desc}</p>
                </div>
                <button className="ds-modal-close" onClick={closeSupport}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>

              {/* Body */}
              <div className="ds-modal-body">
                {submitted ? (
                  <div className="ds-success">
                    <div className="ds-success-icon" style={{ color: form.color }}>
                      <svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                        <polyline points="22 4 12 14.01 9 11.01"></polyline>
                      </svg>
                    </div>
                    <h3 className="ds-success-title">{t('dealer_support_forms.success_title')}</h3>
                    <p className="ds-success-msg">
                      {t('dealer_support_forms.success_msg')}
                    </p>
                    <button className="ds-btn-primary" style={{ background: form.color }} onClick={closeSupport}>
                      {t('dealer_support_forms.btn_done')}
                    </button>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="ds-form">
                    {form.fields.map((field, i) => (
                      <div key={i} className="ds-form-group">
                        <label className="ds-label">{field.label}</label>
                        {field.type === 'select' ? (
                          <select
                            className="ds-input"
                            value={formData[field.label] || ''}
                            onChange={e => handleFormChange(field.label, e.target.value)}
                            required
                          >
                            <option value="">{t('dealer_support_forms.select_default')}</option>
                            {field.options.map(opt => <option key={opt}>{opt}</option>)}
                          </select>
                        ) : field.type === 'textarea' ? (
                          <textarea
                            className="ds-input ds-textarea"
                            placeholder={field.placeholder}
                            value={formData[field.label] || ''}
                            onChange={e => handleFormChange(field.label, e.target.value)}
                            rows={3}
                          />
                        ) : (
                          <input
                            className="ds-input"
                            type={field.type}
                            placeholder={field.placeholder}
                            value={formData[field.label] || ''}
                            onChange={e => handleFormChange(field.label, e.target.value)}
                            required={field.type !== 'date'}
                          />
                        )}
                      </div>
                    ))}
                    <div className="ds-form-footer">
                      <button type="button" className="ds-btn-cancel" onClick={closeSupport}>Cancel</button>
                      <button type="submit" className="ds-btn-primary" style={{ background: form.color }}>
                        {t('dealer_support_forms.btn_submit')}
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
};



export default DealerLocatorPage;


